import  { Fragment, useEffect, useState } from "react";
import {
    useTable,
    useGlobalFilter,
    useSortBy,
    useFilters,
    useExpanded,
    usePagination,
    useRowSelect
} from "react-table";
import { withTranslation } from 'react-i18next';
import { Table, Row, Button } from "reactstrap";
import Paginator from "Components/Common/Paginator";
import DtsTablePlaceholder from "Components/Common/FormBuilder/DtsTablePlaceholder";

interface TableContainerProps {
    columns?: any;
    data?: any;
    tableClass?: any;
    theadClass?: any;    
    setIsReviewOpen: (e: any) => void,
    setRecords: (e: any) => void,
    isPropertyOpen: boolean,
    thClass?: any;
    customPageSize?: any;
    pageChanged: (e: any) => void,
    pagination: any;
    onChangePageSize: (e: any) => void;
    isPageSizeChange?: any;
    props: any;
    dataLoading: boolean;
    model: string
}

const TableContainer = ({
    columns,
    data,
    tableClass,
    theadClass,
    // trClass,
    thClass,
    isPropertyOpen,
    customPageSize,
    isPageSizeChange,
    pageChanged,
    pagination,
    onChangePageSize,
    props,
    dataLoading,
    setIsReviewOpen,
    setRecords,
    model
}: TableContainerProps) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        setPageSize,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: 0, pageSize: customPageSize
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );
    const [isProcessing, setIsProcessing] = useState(true); // 🔹 New State to track data assignment


    const onChangeInSelect = (event: any) => {
        setPageSize(Number(event.target.value));
        onChangePageSize(event.target.value);
    };

    useEffect(() => {
        if (data?.length > 0) {
            setIsProcessing(true); // 🔹 Data received but still processing
        }
    }, [data]);

    // Handle processing state when `page` updates
    useEffect(() => {
        if (!dataLoading && page?.length > 0) {
            setIsProcessing(false); // 🔹 Processing done, page has data
        }
        else if (!dataLoading && !page?.length) {
            setIsProcessing(false);
        }
    }, [page, dataLoading]);
    console.log("data", data,"page", page, "columns", columns, "dataLoading", dataLoading)

    return (
        <div>
            {isPropertyOpen ?             
             <div className="hstack p-5 justify-content-start fw-semibold fs-16 w-100">
                {/* {props.t("common.pagination.data_error")} */}
                Start Searching for duplicates in {model}
            </div>
            :
            <div>
                {dataLoading || isProcessing ?
                    <DtsTablePlaceholder
                        columns={columns}
                        theadClass={theadClass}
                        tableClass="align-middle table-nowrap"
                        thClass="border-bottom-1 table-soft-primary"
                    />
                    :
                    <div>
                        <Row className="align-items-center mb-1 g-3 text-center text-sm-start">
                            <div className="col-sm">
                                <div className="text-muted">
                                    {props.t("common.pagination.showing")}
                                    <span className="fw-semibold ms-1">
                                        {data.length > 0 ? `${(pagination.offset ? pagination.offset : 0) + 1}-${Math.min((pagination.offset ? pagination.offset : 0) + pagination.size, pagination.elements)} ${props.t("common.pagination.of")} ${pagination.elements} ${props.t("common.pagination.results")}` : `0-0 of 0 results`}
                                    </span>
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <Paginator total={pagination && pagination.elements ? pagination.elements : 0}
                                    currentPage={pagination?.page}
                                    pageChanged={(e: any) => pageChanged(e)}
                                    pageSize={pagination.size}
                                    isPageSizeChange={isPageSizeChange}
                                    onChangeInSelect={(e: any) => onChangeInSelect(e)}
                                    pagination={pagination}
                                    props={props}
                                />
                            </div>
                        </Row>
                        {!dataLoading && page && page.length ?
                            <div>
                                <Table responsive={true} hover {...getTableProps()} className={tableClass + 'm-0'}>
                                    <thead className={theadClass}>
                                        {headerGroups.map((headerGroup: any) => (
                                            <tr className={''} key={headerGroup.id}  {...headerGroup.getHeaderGroupProps()}>
                                            
                                                {headerGroup.headers.map((column: any) => (
                                                    <th key={column.id} className={thClass + " fw-bold"}
                                                        {...column.isSortable ? { ...column.getSortByToggleProps() } : ""}>
                                                        <div  title={column.Header}>
                                                            {column.render("Header")}
                                                        </div>
                                                    </th>
                                                ))}
                                                <th className={thClass + " fw-bold text-center"} >
                                                    {props.t("student.listing.columns.actions")}
                                                </th>
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()} style={{ minHeight: 300 }}>
                                        {page.map((row: any) => {
                                            prepareRow(row);
                                            return (
                                                <Fragment key={row.getRowProps().key}>
                                                    <tr style={{ verticalAlign: 'middle', maxHeight: 50 }}>
                                                        {row.cells.map((cell: any) => {
                                                            return (
                                                                <td
                                                                    key={cell.id}
                                                                    style={{ verticalAlign: 'middle' }}
                                                                    className="align-items-center justify-content-between"
                                                                    {...cell.getCellProps()}
                                                                >
                                                                    {cell.render("Cell")}
                                                                </td>
                                                            );
                                                        })
                                                        }
                                                        <td className="text-center">        
                                                            <div>
                                                                <Button
                                                                    onClick={() => { const mergedRecords = row.original?.records.map((r: any) => ({ ...r, ...r.valuesJson })); setRecords(mergedRecords); setIsReviewOpen(true) }}
                                                                    title='Review'
                                                                    size='sm'
                                                                    color="primary"
                                                                    className="hoverbutton ms-1 justfy-self-end btn btn-sm btn-primary remove-list">
                                                                    Review
                                                                </Button>
                                                            </div> 
                                                        </td>
                                                    </tr>
                                                </Fragment>
                                            );
                                        })}
                                    </tbody>
                                </Table></div> :
                            <Table responsive={true} hover {...getTableProps()} className={tableClass + 'm-0'}>
                                <thead className={theadClass}>
                                    {headerGroups && headerGroups.length ? headerGroups.map((headerGroup: any) => (
                                        <tr className={''} key={headerGroup.id}  {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column: any) => (
                                                <th key={column.id} className={thClass + " fw-bold"}
                                                    {...column.isSortable ? { ...column.getSortByToggleProps() } : ""}

                                                >
                                                    <div  className={"cursor-pointer" + `${column.accessor == 'course_name' ? '' : ' otherth'}`} title={column.Header}>
                                                        {column.render("Header")}
                                                        
                                                    </div>
                                                </th>
                                            ))}
                                            <th className={thClass + " fw-bold"} >
                                                {props.t("common.pagination.actions")}
                                            </th>
                                        </tr>
                                    )) : null}
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={headerGroups && headerGroups.length && headerGroups[0].headers.length + 1} className="p-5 fw-semibold fs-16 text-center">
                                            <div className="hstack p-5 justify-content-center fw-semibold fs-16 text-center w-100">
                                                {props.t("common.pagination.data_error")}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>}
                        <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
                            <div className="col-sm">
                                <div className="text-muted">
                                    {props.t("common.pagination.showing")}
                                    <span className="fw-semibold ms-1">
                                        {data.length > 0 ? `${(pagination.offset ? pagination.offset : 0) + 1}-${Math.min((pagination.offset ? pagination.offset : 0) + pagination.size, pagination.elements)} ${props.t("common.pagination.of")} ${pagination.elements} ${props.t("common.pagination.results")}` : `0-0 of 0 ${props.t("common.pagination.results")}`}
                                    </span>
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <Paginator total={pagination && pagination.elements ? pagination.elements : 0}
                                    currentPage={pagination?.page}
                                    pageChanged={(e: any) => pageChanged(e)}
                                    pageSize={pagination.size}
                                    isPageSizeChange={isPageSizeChange}
                                    onChangeInSelect={(e: any) => onChangeInSelect(e)}
                                    pagination={pagination}
                                    props={props}
                                />
                            </div>
                        </Row>
                    </div>}
            </div>
        }</div>
    );
};

export default withTranslation()(TableContainer);